import React, { useEffect, useState } from "react";
import { selectCurrent } from '../redux/theme/selectors'
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { user } from "../redux/user/actions";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { addressBooks } from "../redux/address-books/action";
import storePersist from "../redux/storePersist";
import useWindowDimensions from "../hooks/useWindowsDimensions";

export default function EditProfileAddress({ addressBookId, address }: any) {
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const [steps, setSteps] = useState<any>({})
	const { theme } = useSelector(selectCurrent)
	const [primary, setPrimary] = useState('#FFB934FF')
	const [secondary, setSecondary] = useState('#FFB934FF')
	const [color, setColor] = useState('universal')
	const { height, width } = useWindowDimensions();
	console.log("addressBookId", addressBookId)
	console.log("address", address)
	interface ISteps {
		CategoryName: string;
		ItemName: string
		PackageType: string
		Weight: string
		Width: string
		Height: string
		Length: string
		AdditionalInfo: string
		NumberOfItems: number
	}
	const dispatch = useAppDispatch();
	const handleClose = () => {
		dispatch(user.set({ editProfile: 'close' }))
	}

	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}

	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			setPrimary('#f5e93cac')
			setSecondary('#ffffff')
		}
		else if (theme == 'lightmode') {
			setPrimary('#ffffffa2')
			setSecondary('#000000a2')
		}
		else if (theme == 'universal') {
			setPrimary('#233C64')
			setSecondary('#ffffff')
		}
		else if (theme == 'luxury') {
			setPrimary('#bd238c')
			setSecondary('#ffffff')
		}
		else if (theme == 'harmony') {
			setPrimary('#000000a2')
			setSecondary('#000000a2')
		}
		else if (theme == 'warmth') {
			setPrimary('#000000a2')
		}
		// const data = document.getElementById("layer") as HTMLInputElement;
		// data.setAttribute("fill", "#603812")
		// data.setAttribute("stroke", "#603812")
	}, [theme]);

	const handleSave = () => {
		dispatch(addressBooks.update({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-features/addressbooks/update-address`, entity: 'brands', jsonData: {

				"Records": [
					{
						Id: addressBookId,
						Address: {
							Id: address.Id,
							FirstName: steps?.firstName || address?.FirstName,
							LastName: steps?.lastName || address?.LastName,
							Email: steps?.emailAddress || address?.Email,
							PhoneNumber: steps?.Phone || address?.PhoneNumber,
							Address1: steps?.Address1 || address?.Address1,
							Address2: steps?.Address2 || address?.Address2,
							City: steps?.City || address?.City,
							ZipPostalCode: steps?.PinCode || address?.ZipPostalCode,
							StateProvinceId: '105',
							CountryId: '133',
						}
					}
				]

			}
		})).then(() => {

			handleClose()

		})
	}
	return (
		<>
			{width && width < 720 ?
				//  Start - Mobile View 
				<>
					{address && <div className={`absolute w-auto mt-28 inset-5 z-10 h-[70vh] flex bg-primary rounded-xl shadow-lg justify-center`}>
						<div className="w-full rounded-lg flex flex-col text-white p-4 pb-2">
							<div className="flex items-start justify-between w-full border-b p-2 border-blue-500">
								<div className="flex w-full flex-col items-start justify-between text-xl">
									Edit Address
								</div>
								<div className="cursor-pointer">
									<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x-circle">
										<circle cx="12" cy="12" r="10" />
										<path d="m15 9-6 6" />
										<path d="m9 9 6 6" />
									</svg>
								</div>
							</div>
							<div className="flex w-full flex-col space-y-3 px-2 py-4 overflow-auto">
								<div className="w-full">
									<label
										className="block w-full text-sm font-light mb-1">
										First Name
									</label>
									<input
										disabled
										type="text"
										{...register('firstName', { required: true, maxLength: 15 })}
										className="border-0 px-2 py-2 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="First Name"
										defaultValue={address.FirstName}
										onChange={(e) => handleSteps(e, 'firstName')}
									/>
									{errors.firstName && errors.firstName.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.firstName && errors.firstName.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full">
									<label
										className="block text-sm font-light mb-1" >
										Last Name
									</label>
									<input
										disabled
										type="text"
										{...register('lastName', { required: true, maxLength: 30 })}
										className="border-0 px-2 py-2 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Last Name"
										defaultValue={address.LastName}
										onChange={(e) => handleSteps(e, 'lastName')}
									/>
									{errors.lastName && errors.lastName.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.lastName && errors.lastName.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
									<div className="w-full my-3">
										<label
											className="block w-full text-sm font-light mb-1" >
											Email Address <span className="text-red-800 font-semibold">*</span>
										</label>
										<input
											type="text"
											{...register('emailAddress', {
												required: true,
												pattern:
													/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
											})}
											className="border-0 px-2 py-2 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
											placeholder="Email Address"
											defaultValue={address.Email}
											onChange={(e) => handleSteps(e, 'emailAddress')}
										/>
										{errors.emailAddress && errors.emailAddress.type === "required" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
										)}
										{errors.emailAddress && errors.emailAddress.type === "pattern" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs  px-2">Please enter valid email id</span>
										)}
									</div>

									<div className="w-full my-3">
										<label
											className="block text-sm font-light mb-1" >
											Phone <span className="text-red-800 font-semibold">*</span>
										</label>
										<input
											type="number"
											{...register('Phone', {
												required: true,
												maxLength: 10,
												minLength: 10,
												pattern: /^[0-9+-]+$/
											})}
											className="border-0 px-2 py-2 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
											placeholder="Phone"
											defaultValue={address.PhoneNumber}
											onChange={(e) => handleSteps(e, 'Phone')}
										/>
										{errors.Phone && errors.Phone.type === "required" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
										)}
										{errors.Phone && errors.Phone.type === "maxLength" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs  px-2">Please enter valid mobile number</span>
										)}
										{errors.Phone && errors.Phone.type === "minLength" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs  px-2">Please enter valid mobile number</span>
										)}
										{errors.Phone && errors.Phone.type === "pattern" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs  px-2">Please enter valid mobile number</span>
										)}
									</div>
								</div>
								{/* <div className="w-full">
		<label
			className="block w-full text-sm font-light mb-2" >
			Country*
		</label>
		<div className="px-3 border-0 text-xs bg-white shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" >
			<select
				{...register('Country', { required: true })}
				className="w-full text-xs px-3 py-3 text-black rounded text-sm "
				name="Country"
				onChange={(e) => handleSteps(e, 'Country')}
			>
				<option value="" >--Select--</option>
				<option value="India" >India</option>
			</select>
		</div>
		{errors.Country && errors.Country.type === "required" && (
			<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
		)}
	</div> */}
								<div className="w-full">
									<label
										className="block  text-sm font-light mb-1"
									>
										Address1 <span className="text-red-800 font-semibold">*</span>
									</label>
									<textarea
										{...register('Address1', { required: true, maxLength: 30 })}
										className="border-0 px-2 py-2 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Address1"
										defaultValue={address.Address1}
										onChange={(e) => handleSteps(e, 'Address1')}
									/>
									{errors.Address1 && errors.Address1.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.Address1 && errors.Address1.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full">
									<label
										className="block  text-sm font-light mb-1"
									>
										Address2 <span className="text-red-800 font-semibold">*</span>
									</label>
									<textarea
										{...register('Address2', { required: true, maxLength: 30 })}
										className="border-0 px-2 py-2 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Address2"
										defaultValue={address.Address2}
										onChange={(e) => handleSteps(e, 'Address2')}
									/>
									{errors.Address2 && errors.Address2.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.Address2 && errors.Address2.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full">
									<label
										className="block text-sm font-light mb-1">
										City <span className="text-red-800 font-semibold">*</span>
									</label>
									<input
										type="text"
										{...register('City', { required: true, maxLength: 30 })}
										className="border-0 px-2 py-2 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="City"
										defaultValue={address.City}
										onChange={(e) => handleSteps(e, 'City')}
									/>
									{errors.City && errors.City.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.City && errors.City.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full">
									<label
										className="block text-sm font-light mb-1"
									>
										PinCode <span className="text-red-800 font-semibold">*</span>
									</label>
									<input
										type="text"
										{...register('PinCode', { required: true, maxLength: 30 })}
										className="border-0 px-2 py-2 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="PinCode"
										defaultValue={address.ZipPostalCode}
										onChange={(e) => handleSteps(e, 'PinCode')}
									/>
									{errors.PinCode && errors.PinCode.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.PinCode && errors.PinCode.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
							</div>
							<div className="w-full flex flex-row justify-around items-center text-center pt-3">
								{/* <input type="submit"
									className="bg-gray-800 m-5 text-white hover:bg-[bg-skin-primary] text-xl p-2 w-full cursor-pointer"
									value='Close'
									onClick={() => handleClose()}
								/> */}
								<input type="submit"
									className="bg-hilight m-3 text-black text-xl font-medium p-2 w-full cursor-pointer"
									value='Update'
									onClick={handleSave}
								/>
							</div>

						</div>
					</div >}
				</>
				//  End - Mobile View  
				:
				//  Start - Web View 
				<>
					{address && <div className={`flex bg-gray-50 w-full justify-start text-gray-900`}>
						<div className="w-full  rounded-lg  flex flex-col  text-white p-5">
							<div className="flex items-start justify-between w-full border-b p-2 border-blue-500">
								<div className="flex w-full flex-col items-start justify-between text-xl text-gray-900" >
									Edit Address
								</div>
								{/* <div className="cursor-pointer">
							<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x-circle"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
						</div> */}
							</div>
							<div className="flex w-full flex-col space-y-3 px-8 py-6 overflow-auto text-gray-900" >
								<div className="w-full">
									<label
										className="block w-full text-sm font-light mb-2" >
										First Name
									</label>
									<input
										disabled
										type="text"
										{...register('firstName', { required: true, maxLength: 15 })}
										className="border-0 px-3 w-full py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="First Name"
										defaultValue={address.FirstName}
										onChange={(e) => handleSteps(e, 'firstName')}
									/>
									{errors.firstName && errors.firstName.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.firstName && errors.firstName.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full">
									<label
										className="block text-sm font-light mb-2" >
										Last Name
									</label>
									<input
										disabled
										type="text"
										{...register('lastName', { required: true, maxLength: 30 })}
										className="border-0 w-full px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Last Name"
										defaultValue={address.LastName}
										onChange={(e) => handleSteps(e, 'lastName')}
									/>
									{errors.lastName && errors.lastName.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.lastName && errors.lastName.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
									<div className="w-full my-5">
										<label
											className="block w-full text-sm font-light mb-2" >
											Email Address*
										</label>
										<input
											type="text"
											{...register('emailAddress', {
												required: true,
												pattern:
													/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
											})}
											className="border-0 px-3 w-full py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
											placeholder="Email Address"
											defaultValue={address.Email}
											onChange={(e) => handleSteps(e, 'emailAddress')}
										/>
										{errors.emailAddress && errors.emailAddress.type === "required" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
										)}
										{errors.emailAddress && errors.emailAddress.type === "pattern" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
										)}
									</div>

									<div className="w-full my-5">
										<label
											className="block text-sm font-light mb-2" >
											Phone*
										</label>
										<input
											type="number"
											{...register('Phone', {
												required: true,
												maxLength: 10,
												minLength: 10,
												pattern: /^[0-9+-]+$/
											})}
											className="border-0 w-full px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
											placeholder="Phone"
											defaultValue={address.PhoneNumber}
											onChange={(e) => handleSteps(e, 'Phone')}
										/>
										{errors.Phone && errors.Phone.type === "required" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
										)}
										{errors.Phone && errors.Phone.type === "maxLength" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
										)}
										{errors.Phone && errors.Phone.type === "minLength" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
										)}
										{errors.Phone && errors.Phone.type === "pattern" && (
											<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
										)}
									</div>
								</div>
								{/* <div className="w-full">
							<label
								className="block w-full text-sm font-light mb-2" >
								Country*
							</label>
							<div className="px-3 border-0 text-xs bg-white shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" >
								<select
									{...register('Country', { required: true })}
									className="w-full text-xs px-3 py-3 text-black rounded text-sm "
									name="Country"
									onChange={(e) => handleSteps(e, 'Country')}
								>
									<option value="" >--Select--</option>
									<option value="India" >India</option>
								</select>
							</div>
							{errors.Country && errors.Country.type === "required" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
							)}
						</div> */}
								<div className="w-full">
									<label
										className="block  text-sm font-light mb-2"
									>
										Address1 *
									</label>
									<textarea
										{...register('Address1', { required: true, maxLength: 30 })}
										className="border-0 px-3 py-3   text-black    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Address1"
										defaultValue={address.Address1}
										onChange={(e) => handleSteps(e, 'Address1')}
									/>
									{errors.Address1 && errors.Address1.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.Address1 && errors.Address1.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full">
									<label
										className="block  text-sm font-light mb-2"
									>
										Address2 *
									</label>
									<textarea
										{...register('Address2', { required: true, maxLength: 30 })}
										className="border-0 px-3 py-3   text-black    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Address2"
										defaultValue={address.Address2}
										onChange={(e) => handleSteps(e, 'Address2')}
									/>
									{errors.Address2 && errors.Address2.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.Address2 && errors.Address2.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full">
									<label
										className="block text-sm font-light mb-2" >
										City*
									</label>
									<input
										type="text"
										{...register('City', { required: true, maxLength: 30 })}
										className="border-0 w-full px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="City"
										defaultValue={address.City}
										onChange={(e) => handleSteps(e, 'City')}
									/>
									{errors.City && errors.City.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.City && errors.City.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
								<div className="w-full">
									<label
										className="block   text-sm font-light mb-2"
									>
										PinCode*
									</label>
									<input
										type="text"
										{...register('PinCode', { required: true, maxLength: 30 })}
										className="border-0 px-3 py-3   text-black   rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="PinCode"
										defaultValue={address.ZipPostalCode}
										onChange={(e) => handleSteps(e, 'PinCode')}
									/>
									{errors.PinCode && errors.PinCode.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.PinCode && errors.PinCode.type === "maxLength" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
									)}
								</div>
							</div>
							{/* <div className="w-full flex text-center mt-6">
					<button type="submit"
							className="bg-red-500 text-white text-xl p-2 w-full"
							onClick={handleSave}
						>Save Address  </button>
					</div> */}
							<div className="flex justify-end">
								<div>
									<button
										onClick={() => handleClose()}
										className="m-4 bg-gray-800 text-white hover:bg-[bg-skin-primary] font-semibold p-2 h-14 w-40"
									>
										Close
									</button>
									<button
										onClick={handleSave}
										className="m-4 bg-gray-800 text-white hover:bg-[bg-skin-primary] font-semibold p-2 h-14 w-60"
									>
										Save Address
									</button>
								</div>
							</div>
						</div>
					</div >}
				</>
				//  End - Web View 
			}
		</>
	);
}